

































import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator';
import { onKeyStroke } from '@vueuse/core';
import { Portal } from 'portal-vue';
import { FocusTrap } from 'focus-trap-vue';

import LockBodyScrollMixin from '@/mixins/lock-body-scroll';
import { IconClose } from '@/icons';

@Component({
  components: {
    Portal,
    IconClose,
    FocusTrap,
  },
})
export default class ModalVideoPlayer extends mixins(LockBodyScrollMixin) {
  @Prop(Boolean)
  open!: boolean

  @Prop(String)
  vimeoId!: string

  @Prop(String)
  youtubeId!: string

  @Prop({ type: String, required: true })
  labelledBy!: string

  focusIsTrapped = false;

  get plyrPlayer () {
    // @ts-ignore
    return this.$refs.plyr.player;
  }

  @Watch('open')
  whenOpenChanges (open) {
    open ? this.onOpen() : this.onClose();
  }

  @Watch('$route')
  onRouteChange () {
    this.onClose();
  }

  mounted () {
    onKeyStroke('Escape', this.emitClose);
  }

  onOpen () {
    this.focusIsTrapped = true;
    this.lockScroll(true);
    this.plyrPlayer.play();
    this.plyrPlayer.on('ended', this.emitClose);
  }

  onClose () {
    this.plyrPlayer.pause();
    this.focusIsTrapped = false;
    this.lockScroll(false);
    this.plyrPlayer.off('ended', this.emitClose);
  }

  emitClose () {
    this.$emit('close');
  }
}
